const FilterIcon = ({ orientation }: any) => {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.86856 2.85864C2.4125 2.85864 2.04248 3.23489 2.04248 3.69804V4.19208C2.04248 4.53516 2.17294 4.86508 2.40632 5.11324L4.96386 7.83272L4.96498 7.831C5.45872 8.33647 5.73652 9.01977 5.73652 9.73223V12.1452C5.73652 12.3065 5.90522 12.4094 6.04525 12.3333L7.50172 11.5397C7.72159 11.4196 7.85881 11.1863 7.85881 10.933V9.72595C7.85881 9.01749 8.13267 8.33705 8.62191 7.83272L11.1794 5.11324C11.4123 4.86508 11.5427 4.53516 11.5427 4.19208V3.69804C11.5427 3.23489 11.1733 2.85864 10.7172 2.85864H2.86856Z"
        stroke={orientation !== "" ? "red" : "#130F26"}
        strokeWidth={orientation !== "" ? "1.5" : "0.791687"}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default FilterIcon;
